import { ITranslationStrings } from '../types';

export function prepareResources(
  strings: ITranslationStrings[],
  currentLanguage: string,
  defaultLanguage: string
): Record<string, ITranslationStrings> {
  const resources: Record<string, ITranslationStrings> = {};

  resources[currentLanguage] = strings[0];

  if (strings[1]) {
    resources[defaultLanguage] = strings[1];
  }

  return resources;
}
